module.exports = __webpack_public_path__ + "img/Weronika.13aa9754.jpg";